import React, { FC } from 'react';

import { IconProps } from '../../shared/ui';

export const ShareIcon: FC<IconProps> = ({ width = 16, height = 16, className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.5" cy="3.5" r="2.25" stroke="currentColor" strokeWidth="1.25" />
      <circle cx="3.5" cy="8" r="2.25" stroke="currentColor" strokeWidth="1.25" />
      <circle cx="12.5" cy="12.5" r="2.25" stroke="currentColor" strokeWidth="1.25" />
      <path d="M10.5 4.5L5.5 7M5.5 9L10.5 11.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );
};
